import React from "react";
import { LeadForm } from "../components/LeadForm";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { trackPhoneClick } from "../lib/analytics";

export default function Contact() {
  const { content } = useContent();
  const c = content?.contact || {};
  const phone = c.phone || "+91 90000 00000";
  const email = c.email || "hello@begumsbiryani.com";
  const items = [
    [MapPin, "Visit Us", c.address || "Hazratganj, Lucknow, Uttar Pradesh, India", null],
    [Phone, "Call Us", phone, `tel:${phone.replace(/[^0-9+]/g, "")}`],
    [Mail, "Email", email, `mailto:${email}`],
    [Clock, "Hours", c.hours || "11:00 AM – 11:00 PM, all days", null],
  ];
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10" data-testid="contact-page">
      <div className="text-center mb-8"><div className="overline text-gold">We'd love to hear from you</div><h1 className="font-serif text-4xl sm:text-5xl text-navy mt-1">Contact Us</h1></div>
      <div className="grid lg:grid-cols-2 gap-8">
        <div className="space-y-4">
          {items.map(([Icon, t, d, href], i) => (
            <div key={i} className="bg-white rounded-xl border border-black/5 p-5 flex gap-4">
              <span className="w-10 h-10 rounded-full bg-navy text-gold flex items-center justify-center shrink-0"><Icon size={18} /></span>
              <div><div className="font-semibold text-navy">{t}</div>
                {href ? (
                  <a href={href} onClick={t === "Call Us" ? () => trackPhoneClick() : undefined} data-testid={t === "Call Us" ? "contact-phone-link" : undefined} className="text-sm text-muted-foreground hover:text-gold transition-colors">{d}</a>
                ) : (
                  <div className="text-sm text-muted-foreground">{d}</div>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="bg-white rounded-2xl border border-black/5 p-7">
          <LeadForm source="Contact Us" title="Send a Message" cta="Send Message" fields={["name", "phone", "email", "message"]} />
        </div>
      </div>
    </div>
  );
}
